export type Session = {
  user: { id: string; name: string; email: string };
  permissions: string[];
  csrfToken: string;
};

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    /** The server's error code, e.g. `reauth_required`. */
    readonly code?: string
  ) {
    super(message);
  }
}

export async function api<T>(path: string, session?: Session, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: {
      Accept: "application/json",
      ...(init?.body ? { "Content-Type": "application/json" } : {}),
      ...(session && init?.method && init.method !== "GET"
        ? { "X-Evidite-CSRF": session.csrfToken }
        : {}),
      ...init?.headers
    }
  });
  if (!response.ok) {
    const payload = (await response.json().catch(() => undefined)) as
      | { error?: { message?: string; code?: string } }
      | undefined;
    throw new ApiError(
      payload?.error?.message ?? `Request failed (${response.status})`,
      response.status,
      payload?.error?.code
    );
  }
  return (response.status === 204 ? undefined : await response.json()) as T;
}
